export default '/static/frontend/ReachDigital/12gobiking/dist/assets/ideal-logo-bb68f90b.svg'